module.exports = __webpack_public_path__ + "static/media/RobinHood.de79e596.png";